/* eslint react/prop-types: 0 */
import { Grid } from "@mui/material";
import React, { Suspense } from "react";
import { Route, Redirect } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import { ErrorFallBack } from "@/_components";
import { GridLoader } from "react-spinners";
import Cookies from "universal-cookie";

function PrivateRoute({ component: Component, suspense, ...rest }) {
  const cookies = new Cookies();

  return (
    <Route
      {...rest}
      render={(props) => {
        const user = cookies.get("lifesaferUser");
        if (!user) {
          // not logged in so redirect to login page with the return url
          return (
            <Redirect
              to={{
                pathname: "/account/login",
                state: { from: props.location },
              }}
            />
          );
        }
        // authorized so return component
        if (suspense) {
          return (
            <ErrorBoundary FallbackComponent={ErrorFallBack} onReset={() => {}}>
              <Suspense
                fallback={
                  <Grid
                    container
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    style={{ marginTop: 114 }}
                  >
                    <GridLoader />
                  </Grid>
                }
              >
                <Component {...props} {...rest} />
              </Suspense>
            </ErrorBoundary>
          );
        } else {
          return <Component {...props} {...rest} />;
        }
      }}
    />
  );
}

export { PrivateRoute };
